angular.module('jrUtil', []).filter('replaceParametric', function () {
  const placeholderRegex = /\$(\d)/g;
  return function (input, replacements) {
    return input.replace(placeholderRegex, function (match, p1) {
      return replacements[p1 - 1] !== undefined ? replacements[p1 - 1] : '';
    });
  };
});
